'use client'

import { createContext, type ReactNode, useContext } from 'react'

type LocationProviderType = {
  country?: string | null
}

const LocationContext = createContext<LocationProviderType | null>(null)

type Props = {
  children: ReactNode
  location: LocationProviderType
}

export const LocationProvider = ({ children, location }: Props) => (
  <LocationContext.Provider value={location}>{children}</LocationContext.Provider>
)

export const useLocation = (): LocationProviderType => {
  const location = useContext(LocationContext)

  if (!location) throw new Error('useLocation must be used within LocationProvider')

  return location
}
